import folderIdFactory from 'owa-service/lib/factory/folderId';
import importCalendarEventOperation from 'owa-service/lib/operation/importCalendarEventOperation';
import importCalendarEventRequest from 'owa-service/lib/factory/importCalendarEventRequest';
import ImportCalendarEventResponseMessage from 'owa-service/lib/contract/ImportCalendarEventResponseMessage';
import targetFolderId from 'owa-service/lib/factory/targetFolderId';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

/**
 * Makes the import calendars event call to the server to add the calednar events to your calendar
 * @param content base 64 encoded string of ICS file.
 * @param folderId folder id of the calendar on which the items should be added.
 * @param attachmentId attachment Id of the Ics file whose events will be added to the calednar
 */
export default function importCalendarEventService(
    content: string,
    folderId: string,
    attachmentId: string
): Promise<ImportCalendarEventResponseMessage> {
    return importCalendarEventOperation({
        Header: getJsonRequestHeader(),
        Body: importCalendarEventRequest({
            Content: content,
            ImportedItemFolderId: targetFolderId({
                BaseFolderId: folderIdFactory({ Id: folderId }),
            }),
            AttachmentId: attachmentId,
        }),
    }).then(response => {
        if (response != null && response.Body != null) {
            return response.Body;
        } else {
            throw new Error('[importCalendarOperation failed]');
        }
    });
}
